import type { FC } from 'react';

import { Flex, Row } from 'antd';
import { useRole } from 'hooks/useRole';
import type { User } from 'models/user';

import HeadSection from './header';
import styles from './index.module.css';
import MainCard from './main';
import { AssignedUsers } from './permissions/assigned-users/AssignedUsers';
import { Permissions } from './permissions/Permissions';
import TeamCard from './team';

interface IUserInfoProps {
  userData?: User;
  isAdmin: boolean;
}

const UserInfo: FC<IUserInfoProps> = ({ userData, isAdmin }) => {
  const isAvatarChangeAllowed = useRole(['ADMIN', 'PARTNER']);
  const isTeamsVisible =
    userData && userData.role !== 'PARTNER' && userData.teams && userData.teams.length > 0;
  const isAssignedUsersVisible = isAdmin && userData;

  if (!userData) {
    return null;
  }

  return (
    <>
      <section>
        <Row gutter={8} justify={'space-between'} align={'middle'}>
          <HeadSection userData={userData} isAvatarChangeAllowed={isAvatarChangeAllowed} />
        </Row>

        <Row gutter={8} className={styles.columns}>
          <div className={styles.column}>
            <MainCard userData={userData} />
          </div>

          <Flex className={styles.column} vertical gap={8}>
            {isTeamsVisible &&
              userData.teams &&
              userData.teams.map((team, index) => (
                <div style={{ marginBottom: 8 }} key={index}>
                  <TeamCard team={team} />
                </div>
              ))}

            {isAdmin && <Permissions userData={userData} />}

            {isAssignedUsersVisible && (
              <AssignedUsers id={userData.id} assignedUsers={userData.assignedUsers || []} />
            )}
          </Flex>
        </Row>
      </section>
    </>
  );
};

export default UserInfo;
